//import PricingPage from "../views-template/Pages/PricingPage.jsx";
import LoginPage from "src/views/pages/LoginPage.tsx";
import LogoutPage from "src/views/pages/LogOutPage.tsx";
import LoggingIn from "src/views/pages/LoggingIn"
//import RegisterPage from "../views-template/Pages/RegisterPage.jsx";
//import LockScreenPage from "../views-template/Pages/LockScreenPage.jsx";

// @material-ui/icons
//import PersonAdd from "@material-ui/icons/PersonAdd";
import Fingerprint from "@material-ui/icons/Fingerprint";
//import MonetizationOn from "@material-ui/icons/MonetizationOn";
//import LockOpen from "@material-ui/icons/LockOpen";
import * as types from "src/types"

const pagesRoutes = [
 /* {
    path: "/pages/register-page",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: RegisterPage
  },*/
  {
    path: types.ViewState.getDefaultHash(types.AppSection.LogIn),
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.LogOut),
    name: "Login Out",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LogoutPage
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.LoggingIn),
    name: "Setting Up",
    short: "Setting Up",
    mini: "LP",
    icon: Fingerprint,
    component: LoggingIn
  },
 
  /*{
    path: "/pages/pricing-page",
    name: "Pricing Page",
    short: "Pricing",
    mini: "PP",
    icon: MonetizationOn,
    component: PricingPage
  },
  {
    path: "/pages/lock-screen-page",
    name: "Lock Screen Page",
    short: "Lock",
    mini: "LSP",
    icon: LockOpen,
    component: LockScreenPage
  },
  {
    redirect: true,
    path: "/pages",
    pathTo: "/pages/register-page",
    name: "Register Page"
  }*/
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx